(() => {
  const root=window.Shopify?.routes?.root || '/';
  let queue=Promise.resolve(),checking=false;
  const run=operation=>{const next=queue.then(operation,operation);queue=next.catch(()=>{});return next;};
  const request=async(path,payload)=>{
    const response=await fetch(root+path,{method:payload?'POST':'GET',headers:{'Accept':'application/json',...(payload?{'Content-Type':'application/json'}:{})},...(payload?{body:JSON.stringify(payload)}:{})});
    const result=await response.json();if(!response.ok || result.status)throw new Error(result.description || result.message || window.kyCartStrings.unavailable);return result;
  };
  const ensureAssembly=async()=>{
    let cart=await request('cart.js');
    for(const parent of cart.items.filter(item=>!item.properties?.['Hoort bij'])){
      const props=parent.properties || {},group=props._ky_configuration;
      const mounted=props.Montage===window.kyCartStrings.assembled || Boolean(props._ky_mounting_id);
      if(!mounted)continue;
      const expected=Number(props._ky_mounting_id || window.kyDefaultMounting?.id);
      if(!expected)throw new Error(window.kyCartStrings.unavailable);
      const linked=cart.items.filter(item=>Number(item.variant_id)===expected && (group?item.properties?._ky_configuration===group:item.properties?.['Hoort bij']===parent.product_title));
      const quantity=linked.reduce((sum,item)=>sum+item.quantity,0);
      if(quantity<parent.quantity){
        await request('cart/add.js',{items:[{id:expected,quantity:parent.quantity-quantity,parent_line_key:parent.key,properties:{...(group?{_ky_configuration:group}:{}),_ky_role:'assembly','Hoort bij':parent.product_title}}]});
      }else if(quantity>parent.quantity){
        let remaining=parent.quantity;
        for(const child of linked){const keep=Math.min(child.quantity,remaining);remaining-=keep;if(keep!==child.quantity)await request('cart/change.js',{id:child.key,quantity:keep});}
      }
    }
    cart=await request('cart.js');
    for(const parent of cart.items.filter(item=>!item.properties?.['Hoort bij'])){
      const props=parent.properties || {};
      if(props.Montage!==window.kyCartStrings.assembled && !props._ky_mounting_id)continue;
      const expected=Number(props._ky_mounting_id || window.kyDefaultMounting?.id),group=props._ky_configuration;
      const count=cart.items.filter(item=>Number(item.variant_id)===expected && (group?item.properties?._ky_configuration===group:item.properties?.['Hoort bij']===parent.product_title)).reduce((sum,item)=>sum+item.quantity,0);
      if(count!==parent.quantity)throw new Error(window.kyCartStrings.unavailable);
    }
    return cart;
  };
  window.kyCartGuard={run,ensureAssembly};
  document.addEventListener('submit',event=>{
    const button=event.submitter;
    if(button?.name!=='checkout' && !button?.matches('[data-ky-guard-checkout]'))return;
    event.preventDefault();event.stopImmediatePropagation();if(checking)return;
    checking=true;const previous=button.innerHTML;button.disabled=true;button.textContent=window.kyCartStrings.checking;
    const scope=button.closest('cart-drawer') || document;
    const error=scope.querySelector('[data-cart-guard-error]') || document.getElementById('cart-errors');
    if(error){error.hidden=true;error.textContent='';}
    run(ensureAssembly).then(()=>window.location.assign(root+'checkout')).catch(failure=>{if(error){error.textContent=failure.message || window.kyCartStrings.unavailable;error.hidden=false;}button.disabled=false;button.innerHTML=previous;checking=false;});
  },true);
})();
